import { c as _c } from "react/compiler-runtime";
import { capitalize, MenuItem, Select } from '@mui/material';
import { type Condition } from '@repo/api-gw-sdk';
import { type FilterProperty } from '@/types/advanceFilter';
import { OPERATORS, relationOf } from './OperatorSelect';

/**
 * Operator picker at the top of a filter chip's panel, offering the same operators as the condition builder's
 * `OperatorSelect`. It keeps the values the condition already holds, though: every operator consumes the same list
 * of values, and the common edit here is flipping a filter to its negation — which would be pointless if it
 * emptied the selection first.
 */
export const FilterOperatorSelect = t0 => {
  const $ = _c(12);
  const {
    condition,
    property,
    onChange
  } = t0;
  let t1;
  if ($[0] !== property) {
    t1 = relationOf(property);
    $[0] = property;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const relation = t1;
  const t2 = `filter-operator-${property.name}`;
  const t3 = condition.operator ?? "";
  let t4;
  if ($[2] !== condition || $[3] !== onChange) {
    t4 = event => onChange({
      ...condition,
      operator: event.target.value
    });
    $[2] = condition;
    $[3] = onChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== relation) {
    t5 = Object.entries(OPERATORS[relation]).map(_temp);
    $[5] = relation;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Select fullWidth={true} data-testid={t2} value={t3} onChange={t4}>{t5}</Select>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(t0) {
  const [operator, t1] = t0;
  const {
    label
  } = t1;
  return <MenuItem key={operator} value={operator}>{capitalize(label)}</MenuItem>;
}